export default __webpack_public_path__ + "static/media/lamb.7e9fddbe.jpg";